import { startCase } from "lodash";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { colors } from "../../../../../utils/constant";
import { Order } from "../../../../../../typings/types";
import { Avatar, Grid2 as Grid, TableBody, TableCell, TableRow } from "@mui/material";
import { getComparator, stableSort } from "../../../../custom-components/table-helper/helperTable";
import { useAuth } from "../../../../../context/AuthContext";

interface Props {
  rows: any[];
  order: Order;
  orderBy: string;
}

export function AssessmentTableRows({ rows, order, orderBy }: Props) {
  const navigate = useNavigate();

  const { baseRole: role } = useAuth();
  const onSelect = (data: any) => {
    const lesson_id = data.attributes?.lesson_id ?? data.lesson_id;
    const rawStudents = data?.students?.data ?? data?.students ?? [];
    const student_id = Array.isArray(rawStudents) ? rawStudents[0]?.id : rawStudents?.id;
    if (student_id && lesson_id) {
      navigate(`/${role}/student/${student_id}/lesson/${lesson_id}`);
    }
  };


  return (
    <>
      <TableBody>
        {stableSort(rows, getComparator(order, orderBy))?.map((row: any) => {
          // const students = "";
          // row?.map((x: any) => x.first_name)?.join(", ");

          // The API (GET /api/grading/assessments, assessmentsRouter.ts)
          // returns flat submitted_count/total_students/average_grade/
          // max_score — never submission_percentage or students.class_avg.
          // Those legacy fields are always undefined here, which is why this
          // tile always rendered 0% / 0 (UAT #7).
          const totalStudents = Number(row?.total_students ?? 0);
          const submittedCount = Number(row?.submitted_count ?? 0);
          // No enrolled-student count for this activity (e.g. no class_id) —
          // "0%" would misleadingly read as a real 0-of-N outcome, so show "—".
          const submittedPct =
            totalStudents > 0 ? Math.round((submittedCount / totalStudents) * 100) : null;

          // average_grade is a mean of RAW POINTS (e.g. 8 for an 8/10
          // average), not a percent — normalize by max_score, the same
          // treatment GradedTab.tsx (parentWorkSpace) gives this identical
          // field pair.
          const avgPct =
            row?.average_grade != null && row?.max_score
              ? Math.round((row.average_grade / row.max_score) * 100)
              : null;

          return (
            <TableRow
              hover
              role="checkbox"
              tabIndex={-1}
              key={row.id}
              className="pointer"
              onClick={() => onSelect(row)}
            >
              <TableCell align="left" sx={{ minWidth: "260px" }}>
                <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }} spacing={2}>
                  <Avatar
                    sx={{
                      p: 0.5,
                      width: 32,
                      height: 32,
                      bgcolor: colors.yellow,
                    }}
                    alt={row?.title}
                    src={row?.subject?.icon}
                  />

                  <Grid>{startCase(row?.title)}</Grid>
                </Grid>
              </TableCell>

              <TableCell align="left" sx={{ minWidth: "150px" }}>
                <Grid container alignItems="center" gap={3}>
                  <Grid
                    container
                    sx={{
                      width: "120px",
                      borderRadius: 1.5,
                      overflow: "clip",
                    }}
                  >
                    {row?.grading_component}
                  </Grid>
                </Grid>
              </TableCell>

              <TableCell align="left" sx={{ minWidth: "170px" }}>
                {submittedPct != null ? `${submittedPct}%` : "—"}
              </TableCell>

              <TableCell align="left" sx={{ minWidth: "140px" }}>
                {avgPct != null ? `${avgPct}%` : "—"}
              </TableCell>

              <TableCell align="left" sx={{ minWidth: "180px" }}>
                {row?.due_date ? format(new Date(row.due_date), "MMMM dd, yyyy") : "—"}
              </TableCell>

              {/* <TableCell align="left" sx={{ minWidth: "180px" }}>
                {students}
              </TableCell> */}
            </TableRow>
          );
        })}
      </TableBody>
    </>
  );
}
